<!-- 
	Content and translations will be customized when it needs to be used,
	that's why for now it looks like this for test view.
-->

<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Container, Modal, Text, Button } from '@Shelly/shelly-design-system';
	import { push } from 'svelte-spa-router';
	import { createEventDispatcher, onMount } from 'svelte';
	import { mobile } from 'src/services/mobile-rework';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { version } from 'package.json';
	export let showModal = false;
	export let priority = 80;

	const dispatch = createEventDispatcher();

	$: dealDates = `<span class="text-bold">${$format('', {
		default:
			'Our Premium users are getting 50% OFF on selected Shelly devices in our web shop from {startDate} ot {endDate}.',
		values: {},
	})}</span>`;
	$: mainSentence = $format('', {
		default: '{dealDates} Want in on the deal? All you have to do is upgrade to Premium!',
		values: { dealDates },
	});
	$: freeTrialSentence = `<span class="text-bold">${$format('', {
		default: 'Start your three-month free trial now!',
	})}</span>`;
	$: secondSentence = $format('', {
		default:
			"By subscribing to Premium, you'll not only unlock this amazing discount but also enjoy a range of exclusive benefits such as monthly energy reports, extended statistics & data visualization, and many more. {freeTrialSentence}",
		values: { freeTrialSentence },
	});

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});

	const closeModal = (e: CustomEvent | MouseEvent) => {
		e.preventDefault();
		save_profile('promoBasic', version.split('-')[0]);
		dispatch('close');
	};
</script>

<Modal
	{showModal}
	on:close={closeModal}
	title={$format('', { default: 'Unlock Exclusive Offer!' })}
	zIndex={priority}
>
	<Container slot="content" padding="0">
		<div class="mb-m d-flex align-items-center flex-direction-column">
			<img class="mb-m" src="./images/promo_basic.svg" alt="promo-basic" />
			<p class="h1-styles text-center">
				{$format('', { default: 'Exclusive offer for you:' })}
			</p>
			<p class="h1-styles text-center text-bold text-primary">
				{$format('', { default: 'Become Premium and get 50% off' })}
			</p>
		</div>
		<Text class="mb-s">{$format('', { default: 'Dear Shelly App user,' })}</Text>
		<Text class="mb-m"
			>{$format('', {
				default:
					'As a valued member of the Shelly Smart Control App community, we want to let you in on something special!',
			})}</Text
		>
		<Text class="mb-m">{@html mainSentence}</Text>
		<Text class="mb-m">{@html secondSentence}</Text>
		<Text class="text-small">
			{$format('', {
				default: "Here's how you can join the Premium community:",
			})}
			<ul class="pl-l mt-0 mb-m">
				<li class="text-small">
					{$format('', {
						default: 'Upgrade to Premium by opening the Premium tab on your app',
					})}
				</li>
				<li class="text-small">
					{$format('', {
						default: 'Hit the Subscribe button and follow the steps',
					})}
				</li>
				<li class="text-small">
					{$format('', {
						default: "Once you're a Premium user, claim your 50% OFF promo code",
					})}
				</li>
			</ul>
		</Text>
		<Text class="mb-m"
			>{$format('', {
				default:
					"Don't miss out, upgrade today to take advantage of this limited-time deal and explore all the perks of being a Premium user! We look forward to welcoming you to the Premium family!",
			})}</Text
		>
		<div class="d-flex align-items-center flex-direction-column">
			<Button
				variant="premium"
				class="mb-m text-capitalize"
				id="promo-basic-get-premium-btn"
				aria-label={$format('button_get_premium', { default: 'Get Premium' })}
				on:click={(e) => {
					push('/settings/premium');
					closeModal(e);
				}}
			>
				{$format('button_get_premium', { default: 'Get Premium' })}
			</Button>
			<Text class="link-styles" on:click={closeModal}
				>{$format('button_no_thank_you', { default: 'No, thank you!' })}</Text
			>
		</div>
	</Container>
</Modal>
